export default [
  {
    quote:
      "When a man opens a car door for his wife, it's either a new car or a new wife.",
    attribution: 'Prince Philip',
  },
  {
    quote: "I couldn't find the sports car of my dreams, so I built it myself.",
    attribution: 'Ferdinand Porsche',
  },
  {
    quote: "One person's car is another person's scenery.",
    attribution: 'Jonathan Ive',
  },
  {
    quote: "Shoes make an outfit; they're like rims for a car.",
    attribution: 'Omari Hardwick',
  },
  {
    quote:
      "I've always been asked, 'What is my favorite car?' and I've always said 'The next one.'",
    attribution: 'Carroll Shelby',
  },
  {
    quote:
      "When Henry Ford made cheap, reliable cars people said, 'Nah, what's wrong with a horse?' That was a huge bet he made, and it worked.",
    attribution: 'Elon Musk',
  },
  {
    quote: 'Cars are the sculptures of our everyday lives.',
    attribution: 'Chris Bangle',
  },
  {
    quote: 'I had to stop driving my car for a while... the tires got dizzy.',
    attribution: 'Steven Wright',
  },
  {
    quote: "To attract men, I wear a perfume called 'New Car Interior.'",
    attribution: 'Rita Rudner',
  },
  {
    quote:
      "If you think nobody cares if you're alive, try missing a couple of car payments.",
    attribution: 'Earl Wilson',
  },
  {
    quote: 'The best car safety device is a rear-view mirror with a cop in it.',
    attribution: 'Dudley Moore',
  },
  {
    quote:
      'Generally, cars were not built to sit on dealer lots. It encourages the wrong kind of behavior in the whole system.',
    attribution: 'Rick Wagoner',
  },
  {
    quote: 'Cars are the reason we, you know, people live or die.',
    attribution: 'Steven Curtis Chapman',
  },
  {
    quote: "All of those cars were once just a dream in somebody's head.",
    attribution: 'Peter Gabriel',
  },
  {
    quote:
      'Failure is simply the opportunity to begin again, this time more intelligently.',
    attribution: 'Henry Ford',
  },
  {
    quote: 'A business that makes nothing but money is a poor business.',
    attribution: 'Henry Ford',
  },
  {
    quote: 'Quality means doing it right when no one is looking.',
    attribution: 'Henry Ford',
  },
  {
    quote:
      'Any customer can have a car painted any color that he wants so long as it is black.',
    attribution: 'Henry Ford',
  },
  {
    quote: 'I love fast cars... and to go too fast in them.',
    attribution: 'Lara Flynn Boyle',
  },
  {
    quote:
      "There's a lot of stress... but once you get in the car, all that goes out the window.",
    attribution: 'Dan Brown',
  },
  {
    quote: 'The cars we drive say a lot about us.',
    attribution: 'Alexandra Paul',
  },
  {
    quote:
      "It's a never ending battle of making your cars better and also trying to be better yourself.",
    attribution: 'Dale Earnhardt',
  },
  {
    quote: 'A racing car is an animal with a thousand adjustments.',
    attribution: 'Mario Andretti',
  },
  { quote: 'Fast cars are my only vice.', attribution: 'Michael Bay' },
  {
    quote: 'Never lend your car to anyone to whom you have given birth.',
    attribution: 'Erma Bombeck',
  },
  {
    quote:
      'If all the cars in the United States were placed end to end, it would probably be Labor Day Weekend.',
    attribution: 'Doug Larson',
  },
  {
    quote:
      "People get excited around me and behave differently than they would normally. I don't feel different from anyone else, except that I drive a racing car round in circles faster than somebody else.",
    attribution: 'Michael Schumacher',
  },
  {
    quote:
      "Here comes 40. I'm feeling my age and I've ordered the Ferrari. I'm going to get the whole mid-life crisis package.",
    attribution: 'Keanu Reeves',
  },
  {
    quote:
      "The automobile engine will come, and then I will consider my life's work complete.",
    attribution: 'Rudolf Diesel',
  },
  {
    quote:
      "Say yes to everything. 'You want me to buy you some food?' Yes. 'You want me to buy you a car?' Yes.",
    attribution: 'Cardi B',
  },
  {
    quote: 'I love sleeping in a moving car more than sleeping in bed.',
    attribution: 'Ben Stein',
  },
  {
    quote:
      "I'm as passionate as any car owner or car collector that has one car or 300 cars.",
    attribution: 'Bill Goldberg',
  },
  { quote: 'Cars bring me sheer joy.', attribution: 'Evan Spiegel' },
  {
    quote:
      'A turbo, exhaust gasses go into the turbocharger and spin it, with a supercharger, air goes in, witchcraft happens and you go faster.',
    attribution: ' Jeremy Clarkson',
  },
  {
    quote:
      'There is no doubt about precisely when folks began racing each other in automobiles. It was the day they built the second automobile.',
    attribution: 'Richard Petty',
  },
  {
    quote:
      'Have you ever noticed that anybody driving slower than you is an idiot, and anyone going faster than you is a maniac?',
    attribution: 'George Carlin',
  },
  {
    quote: 'Take it easy driving– the life you save may be mine.',
    attribution: ' James Dean',
  },
  {
    quote:
      "Americans will put up with anything provided it doesn't block traffic.",
    attribution: ' Dan Rather',
  },
  {
    quote: "Don't just stand there; make something happen.",
    attribution: 'Lee Iacocca',
  },
  {
    quote: 'The real secret of success is enthusiasm.',
    attribution: 'Walter Chrysler',
  },
  {
    quote: "You can't stay mad at somebody who makes you laugh.",
    attribution: 'Jay Leno',
  },
  {
    quote:
      "You're a car, but most of all, what you are, what you've become, is a mate. And that's what makes a car special. That's what makes a car great. You start to think of it as a person. You start to love it.",
    attribution: 'Jeremy Clarkson',
  },
  {
    quote: 'Oversteer is best cause you dont see the tree that kills you.',
    attribution: 'Richard Hammond',
  },
  {
    quote:
      'The easiest and simplest thing that any one can do to make their car safer, more gas efficient, whatever - check the tire pressure.',
    attribution: 'Richard Hammond',
  },
  { quote: '...', attribution: 'The Stig' },
]
